import { send } from 'server';
export * from '@core/js/hooks/user/server';

export const removePlayerTags = (tags) => send({
    ID: 35553,
    description: 'Remove player tags',
    responses: [35554, 35555],
    tags: [...tags]
});

export const getClientIP = () => send({
    ID: 81405,
    description: 'IP address detection',
    responses: [81406, 81407]
});

export const getCountryByGeoIP = ({ casinoName }) => send({
    ID: 35685,
    casino: casinoName,
    description: 'Country by Geo IP detection',
    responses: [35686, 35687]
});

export const getDepositLimits = () => send({
    ID: 89901,
    responses: [89905, 89900],
    description: 'Get deposit limits'
});

export const getBalance = subscriptionBalanceTypes => send({
    ID: 31020,
    responses: [31021, 31025],
    description: 'Get Dynamic Balance',
    balanceTypes: subscriptionBalanceTypes
});
